

<div class="pay-confirmation text-center" slot="height: 250px">  
    <!-- <div class="tran-id-box" *ngIf="tranData"> 
    <ul>
      <li>
        <strong> Booking ID :</strong>
        <span id="bookingId"> {{tranData && tranData[0].orderId}}</span>
      </li>
        <li> 
            <strong> Transaction ID :</strong>
            <span id="transactionID"> {{tranData && tranData[0].transactionId}}</span>
        </li>
        <li> 
            <strong> Transaction Total :</strong>
            <span id="totalprice">{{tranData && tranData[0].price | currency}}</span>
        </li>
         <li> 
            <strong> Product Title :</strong>
            <span id="prgname"> {{tranData && tranData[0].itinerary.programName}}</span>
        </li> -->
    <!--    <li> -->
    <!--        <strong> Product Slug (SKU) :</strong>-->
    <!--        <span id="prgnameslug"> {{tranData && tranData[0].itinerary.programSlug}}</span>-->
    <!--    </li>-->
        <!-- <li> 
            <strong> Price :</strong>
            <span id="price">{{tranData && tranData[0].price | currency}}</span>
        </li> -->
      
        <!-- <li> 
            <strong> No.Of People :</strong>
            <span id="quatity"> {{tranData && tranData[0].itinerary.people}}</span>
        </li> -->
    <!-- </ul> -->
    <!-- </div> --> 
    <!-- *ngIf="urlParam.type=='success'" -->
    <div class="msg" > 
    <span> <img src="assets/images/check4.png" alt=""/></span>
    <h3>Thank You!<br/>Your order request has been sent successfully. 
         <br/>
    </h3>
    </div>
    <!-- <div class="msg" *ngIf="urlParam.type!='success'">     
        <span> <img src="assets/images/cross.png" alt=""/></span>
        <h3> Transaction failed</h3>     
    </div> -->
    </div>
    
